import _ from 'lodash'
// Utils
import slugify from '../utils/slugify'
// Types
import type {ParentCategory} from '../types/ballot'
// Styles
import styles from './group-list.module.scss'
import BoundLink from './bound-link'

const optimizeImageUrl = (url: string | undefined, height: number, width: number): string | null => {
  if (!url) return null
  if (!_.startsWith(url, 'https://ucarecdn.com/')) return null
  return `${url}-/scale_crop/${width}x${height}/center/-/quality/smart/-/progressive/yes/`
}

interface GroupListProps {
  groups: ParentCategory[]
  currentGroup: ParentCategory | null
  title?: string
}

const GroupList = ({
  groups,
  currentGroup,
  title = 'Select a group',
}: GroupListProps) => {
  return !_.isEmpty(groups)
    ? (
      <div className={styles['group-list']}>
        <h2 className={styles['__title']}>{title}</h2>
        {_.map(groups, group => {
          return (
            <BoundLink
              key={group._id}
              href={`/${slugify(group.parent_category_name)}`}
              className={styles['__group-link']}
              shallow={true}
              style={{
                backgroundImage: `url(${optimizeImageUrl(group?.parent_images?.groupCoverImagePath, 394, 563)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundColor: '#dbdbdb',
              }}
              data-active={group.parent_category_name === currentGroup?.parent_category_name}
            >
              <h2 className={styles['__group-link-title']}>{group.parent_category_name}</h2>
            </BoundLink>
          )
        })}
      </div>
    )
    : null
}

export default GroupList
